import { http, api } from '@/services/api';
import type { Me } from '@/types/user';

/** Totem da cabine — API source/cabin/totem (o dispositivo se identifica pelo header x-cabin-token). */
export interface CabinStatus {
  id: string;
  code: string;
  subdomain: string;
  establishmentName: string;
  city: string;
  state: string;
  hilabEnabled: boolean;
  available: boolean;
  reason: 'ok' | 'inactive' | 'offline' | 'outside_schedule';
  message: string | null;
  schedules: { weekday: number; startTime: string; endTime: string }[];
  biometricDriver: 'mock' | 'faceapi';
  devCpfLogin: boolean;
}

const h = (token: string) => ({ 'x-cabin-token': token });
export const getCabinStatus = (token: string) => api<CabinStatus>('/cabin/totem/status', { headers: h(token) });
export const sendHeartbeat = (token: string) => api<CabinStatus>('/cabin/totem/heartbeat', { method: 'POST', headers: h(token) });
export const totemLogin = (token: string, body: { descriptor: number[] } | { cpf: string }) =>
  api<{ user: Me }>('/cabin/totem/login', { method: 'POST', headers: h(token), body, skipRefresh: true });
export const totemLogout = () => http.post<{ ok: boolean }>('/cabin/totem/logout');
